<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>Beat the Turtle Drum</span></p>
<p class="authorname"><span>Constance C. Greene</span></p>
<p class="publisher"><span><img alt="image" class="svg" src="images/fig_01.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?0851d1ae